import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { DotButton, useDotButton } from './EmblaCarouselArrowButtons'
import { getData } from '@/app/funcs/api'
import Link from 'next/link'
import formatArabicDate from '@/app/funcs/FormatArabicDate'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import {
    PrevButton,
    NextButton,
    usePrevNextButtons
} from './usePrevNextButtons'
import './embala.css'
import { useEffect } from 'react'
import Image from 'next/image'
export const EmblaCarousel = (props) => {
    // const { slides, options } = props
    const { isService, sectionType, options, img, link, controls, count, data } = props

    const [emblaRef, emblaApi] = useEmblaCarousel(options)
    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi)

    // Derive from `data` only: null/undefined = loading; [] = loaded empty; was [] truthy before → zero-height carousel
    const items = Array.isArray(data) ? data : [];
    const isLoading = data === null || data === undefined;
    const hasSlides = items.length > 0;

    useEffect(() => {
        if (emblaApi && hasSlides) emblaApi.reInit();
    }, [emblaApi, hasSlides, items.length]);

    return (
        <>

            {isLoading ? (
                <SkeletonTheme color="#202020" baseColor="#202020" highlightColor="#303030">
                    <div className="row">
                        <Skeleton className='rounded-5' containerClassName='col-4' count={1} height={150} />
                        <Skeleton className='rounded-5' containerClassName='col-4' count={1} height={150} />
                        <Skeleton className='rounded-5' containerClassName='col-4' count={1} height={150} />
                    </div>
                </SkeletonTheme>
            ) : hasSlides ? (
                <section id={props.id} className={`embla ${props.classes ? props.classes : ''} my-4 mx-0`} dir='rtl'>
                    <div className="embla__viewport" ref={emblaRef}>
                        <div className="embla__container">

                            {items.map((index, i) => {
                                let linkIs = '#';

                                if (index?.link) {
                                    linkIs = index.link;
                                } else if (link) {
                                    linkIs = link;
                                } else if (sectionType == 'short_ad') {
                                    // homeFeedApi maps REST → acfShorts; support raw REST acf.* as fallback
                                    linkIs =
                                        index?.acfShorts?.shortAdLink ||
                                        index?.acf?.short_ad_link ||
                                        index?.acf?.shortAdLink ||
                                        '#';
                                } else {
                                    let sectionPrefix = '';
                                    isService ? sectionPrefix = '/services/' : sectionPrefix = '/sections/'
                                    linkIs = sectionPrefix + sectionType + '/' + index?.id;
                                }

                                const shortAdLinkTypes =
                                    index?.acfShorts?.linkType?.length
                                        ? index.acfShorts.linkType
                                        : index?.acf?.link_type != null
                                            ? Array.isArray(index.acf.link_type)
                                                ? index.acf.link_type
                                                : [index.acf.link_type]
                                            : [];

                                return (
                                    <div className={`embla__slide`} key={index.id}>
                                        <Link
                                            href={linkIs}
                                            className={`embla__slide__link embla__slide__number ${props?.section?.bg ? 'bg-white' : 'bg-transparent border-0 shadow-none text-center'} d-block rounded-4`}
                                            target={shortAdLinkTypes[0] === 'External' ? '_blank' : ''}
                                        >
                                            {img && index?.featuredImage?.node?.sourceUrl && (
                                                <Image
                                                    src={index.featuredImage.node.sourceUrl}
                                                    alt=''
                                                    className={`img-fluid object-fit-cover p-0 ${img.width === 'full' ? 'w-100' : 'fit'}  shadow-sm ${img?.class}`}
                                                    width={img.width === 'full' ? img.width : img.width}
                                                    height={img.height === 'full' ? img.height : img.height}
                                                    sizes={`(max-width: 768px) 100vw, ${img.height}`}
                                                    priority={i === 0}
                                                    placeholder="empty"
                                                />
                                            )}
                                            {/* {props?.section?.title || index.title && ( */}
                                            {index.title && (
                                                <b className='d-block'>{index.title}</b>
                                            )}

                                            {index.subtitle && (
                                                <span className='d-block small text-muted mt-1 px-1 lh-sm'>{index.subtitle}</span>
                                            )}

                                            {index?.date && (
                                                <p className='d-block ps-2 text-muted mb-0 dateTime'> <i className='bi bi-calendar3'></i> {formatArabicDate(index?.date)}</p>
                                            )}

                                            {index?.author?.node?.name && (
                                                <p className='d-block ps-2 text-muted authorName'> <i className='bi bi-person-circle'></i> {index?.author?.node?.name}</p>
                                            )}

                                        </Link>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                    {/* {controls && (
                        <div className="embla__controls">
                            <div className="embla__buttons">
                                <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                                <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                            </div>
                            <div className="embla__dots">
                                {scrollSnaps.map((_, index) => (
                                    <DotButton
                                        key={index}
                                        onClick={() => onDotButtonClick(index)}
                                        className={'embla__dot'.concat(
                                            index === selectedIndex ? ' embla__dot--selected' : ''
                                        )}
                                    />
                                ))}
                            </div>
                        </div>
                    )} */}
                </section>
            ) : null}
        </>
    )
}

// export default EmblaCarousel
